import { chipTones } from '../../domain/constant/crm/crm.chip.constant';
import { getToneClassName, toneIntensities } from '../../domain/constant/tone.constant';

const Chip = ({ tone = chipTones.neutral, children }) => (
    <span
        className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium leading-normal ${
            getToneClassName(tone, toneIntensities.strong)
        }`}
    >
        {children}
    </span>
);

export default Chip;
